 
import { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import { Row, Col } from "react-bootstrap";
import { WebLayout } from "../../components/web-layout";
import OTPDeliverMethod from "./otp-deliver-method";
import VerifyOTP from "./verify-otp";
import { OptResponse } from "./types";

interface Props {
    email: string;
    backToLogin: () => void;
    redirectPathName?: string;
}

export default function LoginWithCode({
    email,
    backToLogin,
    redirectPathName,
}: Props) {
    const [showOtpBox, setShowOtpBox] = useState<boolean>(false);
    const [deliveryMode, setDeliveryMode] = useState<OptResponse>({
        deliverOption: "email",
        receiver: null,
    });
    const { hash } = useLocation();

    const onGenerateOtp = ({ deliverOption, receiver }: OptResponse) => {
        setShowOtpBox(true);
        setDeliveryMode({ deliverOption, receiver });
    };

    useEffect(() => {
        if (!hash) {
            backToLogin();
        }
    }, [hash, backToLogin]);

    return (
        <WebLayout showOtpBanner={showOtpBox} otpDeliveryMode={deliveryMode}>
            {showOtpBox ? (
                <VerifyOTP
                    email={email}
                    deliveryMode={deliveryMode.deliverOption}
                    redirectPathName={redirectPathName}
                />
            ) : (
                <Row>
                    <Col
                        xs={12}
                        md={{ offset: 2, span: 8 }}
                        lg={{ offset: 2, span: 8 }}
                    >
                        <OTPDeliverMethod
                            onOptSuccess={onGenerateOtp}
                            email={email}
                        />
                    </Col>
                </Row>
            )}
        </WebLayout>
    );
}
